import React from 'react';
import styles from './styles.module.scss';

/**
 * Bounded scroll container for a ContentLayout mobile overlay (a full-screen
 * form that replaces the tab swiper). Same geometry as a tab slide: it fills
 * the space between the tab strip and the BottomNav and scrolls inside, so the
 * document stays viewport-tall and never scrolls under the fixed chrome.
 */
export const MobileOverlay: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.container}>
    <div className={styles.scroll}>{children}</div>
  </div>
);

export default MobileOverlay;
